import { jsx as _jsx } from "react/jsx-runtime";
import { getTiposLogradouros } from '../../../api';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 650 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export default function TiposLogradouros() {
    return (_jsx(GridBase, { pagina: PAGINAS.TIPOS_LOGRADOUROS, paginaPermissao: FUNCIONALIDADES.TIPOS_LOGRADOUROS, rota: ROUTES.TIPOS_LOGRADOUROS, fetchData: function (str, _, pag) { return getTiposLogradouros(str, pag); }, columns: COLUNAS }));
}
